export const INTEGRATE_MAILCHIMP =
  'APP/STORES/PLATFORM_COMPONENT/EMAIL/MAILCHIMP/INTEGRATE'
export const INTEGRATE_MAILCHIMP_SUCCESS =
  'APP/STORES/PLATFORM_COMPONENT/EMAIL/MAILCHIMP/INTEGRATE_SUCCESS'
export const INTEGRATE_MAILCHIMP_ERROR =
  'APP/STORES/PLATFORM_COMPONENT/EMAIL/MAILCHIMP/INTEGRATE_ERROR'
